$(document).ready(function () {
	removeUrlParameter("contact-processed");
});